import { cn } from "@ando/ui";

import type { CatalogEntry } from "../catalog";
import { vendorIcon } from "./vendorIcons";

/**
 * Square 36×36 badge — renders the vendor brand SVG when the row has a
 * known primary connection, otherwise falls back to the spec's Lucide
 * icon. ``muted`` swaps the colored brand tone for neutral ink-3 (used
 * in disconnected / errored states).
 */
export interface CapabilityBadgeProps {
  readonly entry: CatalogEntry;
  readonly primaryVendor?: string | null;
  readonly muted?: boolean;
}

export const CapabilityBadge: React.FC<CapabilityBadgeProps> = ({
  entry,
  primaryVendor,
  muted = false,
}) => {
  const brand = vendorIcon(primaryVendor ?? undefined, "h-5 w-5");
  return (
    <div
      aria-hidden
      className={cn(
        "flex h-9 w-9 shrink-0 items-center justify-center rounded-md",
        muted
          ? "bg-white/70 text-ink-2 ring-1 ring-hairline transition-colors group-hover:text-ando-orange"
          : brand
            ? "bg-white/70"
            : "bg-accent/10 text-accent",
      )}
    >
      {brand ?? entry.spec.icon}
    </div>
  );
};
CapabilityBadge.displayName = "CapabilityBadge";
